
<div class="modal-dialog" style="max-width: 800px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col">
        <h4 class="modal-title">Purchase Order Offers</h4>
      </div>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <div class="container">
        <error [error]="error"></error>
        <success></success>
        <div *ngIf="loading">
          <md-spinner-block></md-spinner-block>
        </div>
        <div class="row">
          <div class="col-12">
            <list-controls class="mb-4" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [showLimit]="false" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
          </div>
          <div class="col-12">
            <table class="table table-bordered border-top-0 light-blue-table">
              <thead>
                <tr>
                  <th class="pl-5">DART Offer</th>
                  <th>Offer Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dartOffer of dartOffersDisplay; index as i" [ngIf]="dartOffers.length" [ngClass]="{'disabled-content': dartOffer.disabled}">
                  <td class="pl-3">
                    <div class="form-check">
                      <input class="form-check-input float-left" type="checkbox" [(ngModel)]="dartOffer.selected" (change)="offerSelected(dartOffer)" [disabled]="dartOffer.disabled">
                      <label class="float-left">{{dartOffer.offerNumber}}</label>
                    </div>
                  </td>
                  <td>{{dartOffer.offerDescription}}</td>
                </tr>
                <tr *ngIf="!dartOffersDisplay.length">
                  <td colspan="2">
                    <p class="text-center empty-table-message">There are no dart offers to display.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div style="display: block;width: 100%;">
        <button class="btn btn-outline-primary col-2 float-right" type="button" (click)="save()">Save</button>
        <button class="btn btn-outline-secondary mr-3 col-2 float-right" type="button" title="Cancel" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>